import { motion, useReducedMotion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...props }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? { opacity: 0 } : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
      {...props}
    >
      {children}
    </motion.div>
  );
};

export const Eyebrow = ({ children, className = "" }) => (
  <span
    className={`inline-flex items-center gap-2 text-sm uppercase tracking-[0.22em] font-bold text-sage ${className}`}
  >
    <span className="h-px w-8 bg-sage/60" aria-hidden />
    {children}
  </span>
);
